export const LAPTOP_MIN_WIDTH = 1024;

export const belowLaptopMediaQuery = `max-width: ${LAPTOP_MIN_WIDTH - 1}px`;
